<div class="root-container">
  <button mat-flat-button [color]="color" [disabled]="loading">{{ label }}</button>
  <div class="progress" *ngIf="loading">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div>
</div>
